module.exports = __webpack_public_path__ + "static/img/47-2.58d8737.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/47-2.jpg
// module id = aiOF
// module chunks = 0